import { PrimaryColor } from "meta/utils/colors";
export const nestedMenuWidth = 220;
export const fontColor = "white";
export const menuBackgroundColor = PrimaryColor;
export const hoverColor = "rgba(255, 255, 255, 0.25)";
